import { createSlice } from "@reduxjs/toolkit";

const transactionsSlice = createSlice({
  name: "transactions",
  initialState: {
    loading: false,
    transactions: [],
    error: null,
    total: 0,
    page: 0,
    limit: 10,
    invoiceLoading: false,
    invoiceData: null,
    invoiceError: null,
  },
  reducers: {
    fetchTransactionsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTransactionsSuccess: (state, action) => {
      state.loading = false;
      state.transactions = {
        transactionData: action.payload.transactionData,
        total: action.payload.total,
        recordsFiltered: action.payload.recordsFiltered,
      };
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      console.log("FETCH LIMIT SENT TO BACKEND:", action.payload.limit);
    },
    fetchTransactionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchInvoiceRequest: (state) => {
      state.invoiceLoading = true;
      state.invoiceError = null;
    },
    fetchInvoiceSuccess: (state, action) => {
      state.invoiceLoading = false;
      state.invoiceData = action.payload;
    },
    fetchInvoiceFailure: (state, action) => {
      state.invoiceLoading = false;
      state.invoiceError = action.payload;
    },
    exportTransactionsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    exportTransactionsSuccess: (state) => {
      state.loading = false;
    },
    exportTransactionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    verifyPaymentRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    verifyPaymentSuccess: (state, action) => {
      state.loading = false;
      state.verifyPaymentResponse = action.payload;
    },
    verifyPaymentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

  },
});

export const {
  fetchTransactionsRequest,
  fetchTransactionsSuccess,
  fetchTransactionsFailure,
  fetchInvoiceRequest,
  fetchInvoiceSuccess,
  fetchInvoiceFailure,
  exportTransactionsRequest,
  exportTransactionsSuccess,
  exportTransactionsFailure,
  verifyPaymentRequest,
  verifyPaymentSuccess,
  verifyPaymentFailure,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
